import React from 'react';
import { ValidatingFormComponent } from '@/hybrid/formbuilder/formBuilder.module';
import { IdentityPreviewV1 } from '@/sdk';
import { SelectIdentity } from '@/hybrid/core/SelectIdentity.molecule';
import { Field, useForm } from 'react-final-form';
import { getFormFieldProps, getValidationFunction } from './formbuilder.utilities';
import { useShowError } from './hooks/useShowError';
import { FormError } from '../core/FormError.atom';
import classNames from 'classnames';

export interface SelectIdentityIF extends ValidatingFormComponent<Partial<IdentityPreviewV1>> {
  component: 'SelectIdentityFormComponent';
  name: string;
  placeholder?: string;
  unauthorizedTooltip?: string;
  idForLabel?: string;
  allowGroups?: boolean;
  includeAllProperties?: boolean;
  startEditable?: boolean;
  multiple?: boolean;
  autoFill?: boolean;
  clearIdentityWhenEmpty?: boolean;
}

export const SelectIdentityFormComponent: React.FunctionComponent<SelectIdentityIF> = (props) => {
  const {
    idForLabel,
    allowGroups,
    includeAllProperties,
    startEditable,
    placeholder,
    extraClassNames,
    tooltip,
    unauthorizedTooltip,
    multiple,
    testId = 'selectIdentity',
    name,
    extendValidation,
    validation,
    customErrorText,
    autoFill,
    value,
    skipStore,
    clearIdentityWhenEmpty,
  } = props;

  const formState = useForm().getState();
  const { showError, setShowError } = useShowError(false);

  const defaultValidation = (value: Partial<IdentityPreviewV1>) => (multiple ? value?.id : !value?.id);

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  return (
    <div className={classNames('flexRowContainer', extraClassNames)} data-testid={testId}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const formFieldProps = getFormFieldProps(formState, input, meta, props);
          setShowError(formFieldProps.showError);

          return (
            <SelectIdentity
              setIdentity={formFieldProps.onChange}
              identity={skipStore ? input.value : value}
              placeholder={placeholder}
              tooltip={tooltip}
              unauthorizedTooltip={unauthorizedTooltip}
              idForLabel={idForLabel}
              allowGroups={allowGroups}
              includeAllProperties={includeAllProperties}
              startEditable={startEditable}
              multiple={multiple}
              isInvalid={showError}
              autoFill={autoFill}
              clearIdentityWhenEmpty={clearIdentityWhenEmpty}
            />
          );
        }}
      </Field>
      {showError && customErrorText && <FormError errorText={customErrorText} dataTestId={`${testId}Error`} />}
    </div>
  );
};
